export enum RolesEnum {
    Anonymous = 0,
    Netvote = 1,
    Operator = 20
}
